import { render, staticRenderFns } from "./SeatListNew.vue?vue&type=template&id=9bf67fbe&scoped=true&"
import script from "./SeatListNew.vue?vue&type=script&lang=js&"
export * from "./SeatListNew.vue?vue&type=script&lang=js&"
import style0 from "./SeatListNew.vue?vue&type=style&index=0&id=9bf67fbe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf67fbe",
  null
  
)

export default component.exports